// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","FiltersNav":"U-23f1","AltTheme":"_1ADBDW","item":"_27-9jz","active":"_34BNV7","fadeInFrames":"I183jM"};